import { Attachment, Message } from '../models/chat.model';

/** Types de message dont le `content` backend est du JSON d'Attachment, pas du texte. */
const ATTACHMENT_TYPES = new Set<Message['type']>(['image', 'document', 'video']);

/** `content` n'est une pièce jointe que si le JSON est valide et porte une clé — sinon texte normal. */
export function parseAttachment(type: Message['type'], content: string): Attachment | undefined {
    if (!ATTACHMENT_TYPES.has(type)) return undefined;
    try {
        const parsed = JSON.parse(content) as Partial<Attachment>;
        if (parsed && typeof parsed.key === 'string') return parsed as Attachment;
    } catch { /* content n'est pas une pièce jointe valide, traiter comme texte */ }
    return undefined;
}

/**
 * Aperçu court pour la liste de conversations. Pas de traduction ici — même précédent
 * que le préfixe `✅` des tâches un peu plus bas, jamais traduit non plus. Utilisé à la
 * fois par sendMessage (aperçu optimiste) et fetchConversations (aperçu venant du
 * serveur) : sans ça, le second écrasait le premier avec le JSON brut de la pièce jointe
 * au polling suivant.
 */
export function conversationPreview(type: Message['type'], content: string): string {
    const attachment = parseAttachment(type, content);
    if (attachment) {
        if (type === 'image') return '📷 Photo';
        if (type === 'video') return '🎥 Vidéo';
        return '📎 Document';
    }
    if (type === 'missed_call') return content === 'video' ? '📹 Appel vidéo manqué' : '📞 Appel manqué';
    return type === 'task' ? `✅ ${content}` : content;
}
